import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'button-block',
  templateUrl: './button-block.component.html',
  styleUrls: ['./button-block.component.css']
})
export class ButtonBlockComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
